/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateAddressDto } from './CreateAddressDto';
import {
    CreateAddressDtoFromJSON,
    CreateAddressDtoFromJSONTyped,
    CreateAddressDtoToJSON,
    CreateAddressDtoToJSONTyped,
} from './CreateAddressDto';

/**
 * 
 * @export
 * @interface CreateRealEstateCommandDto
 */
export interface CreateRealEstateCommandDto {
    /**
     * 
     * @type {CreateAddressDto}
     * @memberof CreateRealEstateCommandDto
     */
    address: CreateAddressDto;
    /**
     * 
     * @type {string}
     * @memberof CreateRealEstateCommandDto
     */
    personId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRealEstateCommandDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateRealEstateCommandDto
     */
    area: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRealEstateCommandDto
     */
    roomCount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRealEstateCommandDto
     */
    monthlyRent?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRealEstateCommandDto
     */
    charges?: number;
    /**
     * 
     * @type {Blob}
     * @memberof CreateRealEstateCommandDto
     */
    photo?: Blob;
    /**
     * 
     * @type {number}
     * @memberof CreateRealEstateCommandDto
     */
    propertyType: number;
    /**
     * 
     * @type {number}
     * @memberof CreateRealEstateCommandDto
     */
    rentalType?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRealEstateCommandDto
     */
    riskId?: string;
}

/**
 * Check if a given object implements the CreateRealEstateCommandDto interface.
 */
export function instanceOfCreateRealEstateCommandDto(value: object): value is CreateRealEstateCommandDto {
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('area' in value) || value['area'] === undefined) return false;
    if (!('roomCount' in value) || value['roomCount'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    return true;
}

export function CreateRealEstateCommandDtoFromJSON(json: any): CreateRealEstateCommandDto {
    return CreateRealEstateCommandDtoFromJSONTyped(json, false);
}

export function CreateRealEstateCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRealEstateCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'address': CreateAddressDtoFromJSON(json['address']),
        'personId': json['personId'],
        'name': json['name'],
        'area': json['area'],
        'roomCount': json['roomCount'],
        'monthlyRent': json['monthlyRent'] == null ? undefined : json['monthlyRent'],
        'charges': json['charges'] == null ? undefined : json['charges'],
        'photo': json['photo'] == null ? undefined : json['photo'],
        'propertyType': json['propertyType'],
        'rentalType': json['rentalType'] == null ? undefined : json['rentalType'],
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
    };
}

export function CreateRealEstateCommandDtoToJSON(json: any): CreateRealEstateCommandDto {
    return CreateRealEstateCommandDtoToJSONTyped(json, false);
}

export function CreateRealEstateCommandDtoToJSONTyped(value?: CreateRealEstateCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': CreateAddressDtoToJSON(value['address']),
        'personId': value['personId'],
        'name': value['name'],
        'area': value['area'],
        'roomCount': value['roomCount'],
        'monthlyRent': value['monthlyRent'],
        'charges': value['charges'],
        'photo': value['photo'],
        'propertyType': value['propertyType'],
        'rentalType': value['rentalType'],
        'riskId': value['riskId'],
    };
}

